// author :Renuka
const hexToRgb = (input) => {
  input = input + "";
  input = input.replace("#", "");
  let hexRegex = /[0-9A-Fa-f]/g;
  if (!hexRegex.test(input) || (input.length !== 3 && input.length !== 6)) {
    throw new Error("input is not a valid hex color.");
  }
  if (input.length === 3) {
    let first = input[0];
    let second = input[1];
    let last = input[2];
    input = first + first + second + second + last + last;
  }
  input = input.toUpperCase();
  let first = input[0] + input[1];
  let second = input[2] + input[3];
  let last = input[4] + input[5];
  return (
    parseInt(first, 16) +
    ", " +
    parseInt(second, 16) +
    ", " +
    parseInt(last, 16)
  );
};

// ##############################
// // // Variables - Styles that are used on more than one component
// #############################

const drawerWidth = 260;

const transition = {
  transition: "all 0.33s cubic-bezier(0.685, 0.0473, 0.346, 1)",
};

const container = {
  paddingRight: "15px",
  paddingLeft: "15px",
  marginRight: "auto",
  marginLeft: "auto",
};

const defaultFont = {
  fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
  fontWeight: "300",
  lineHeight: "1.5em",
};

const primaryColor = ["#9c27b0", "#ab47bc", "#8e24aa", "#af2cc5"];
const warningColor = ["#ff9800", "#ffa726", "#fb8c00", "#ffa21a"];
const orangeColor = ["#e69206", "#e69206", "#e69206", "#e69206"];
const dangerColor = ["#f44336", "#ef5350", "#e53935", "#f55a4e"];
const successColor = ["#43a047", "#43a047", "#43a047", "#43a047"];
const singlegreenColor = ["#239b56", "#239b56", "#239b56", "#239b56"];
const multiplegreenColor = ["#2ecc71", "#2ecc71", "#2ecc71", "#2ecc71"];
const deviceColor = ["#880e4f", "#880e4f", "#880e4f", "#880e4f"];
const redvoiletColor = ["#00e676", "#00e676", "#00e676", "#00e676"];
// const infoColor = ["#00acc1", "#26c6da", "#00acc1", "#00d3ee"];
const navyblueColor = ["#512da8", "#512da8", "#512da8", "#512da8"];
const infoColor = ["#007bff", "#007bff", "#007bff", "#007bff"];
const cyanColor = ["#17a2b8", "#17a2b8", "#17a2b8", "#17a2b8"];
const greenColor = ["#42f56c", "#42f56c", "#42f56c", "#42f56c"];
const lightgreenColor = ["#89C35C", "#89C35C", "#89C35C", "#89C35C"];
const lightblueColor = ["#2980b9", "#2980b9", "#2980b9", "#2980b9"];
const lightorangeColor = ["#FDD017", "#FDD017", "#FDD017", "#FDD017"];
const roseColor = ["#e91e63", "#ec407a", "#d81b60", "#eb3573"];
const darkgreenColor = ["#B0BF1A", "#B0BF1A", "#B0BF1A", "#B0BF1A"];
const brownColor = ["#795548", "#795548", "#795548", "#795548"];
const pinkColor = ["#ec407a", "#ec407a", "#ec407a", "#ec407a"];
const neonColor = ["#59698D", "#59698D", "#59698D", "#59698D"];
const licenseColor = ["#33CCCC", "#33CCCC", "#33CCCC", "#33CCCC"];
const grayColor = [
  "#999",
  "#777",
  "#3C4858",
  "#AAAAAA",
  "#D2D2D2",
  "#DDD",
  "#b4b4b4",
  "#555555",
  "#333",
  "#a9afbb",
  "#eee",
  "#e7e7e7",
];

const blackColor = "#000";
const whiteColor = "#FFF";
// const blueColor = "#007bff";

const boxShadow = {
  boxShadow:
    "0 10px 30px -12px rgba(" +
    hexToRgb(blackColor) +
    ", 0.42), 0 4px 25px 0px rgba(" +
    hexToRgb(blackColor) +
    ", 0.12), 0 8px 10px -5px rgba(" +
    hexToRgb(blackColor) +
    ", 0.2)",
};

const primaryBoxShadow = {
  boxShadow:
    "0 4px 20px 0 rgba(" +
    hexToRgb(blackColor) +
    ",.14), 0 7px 10px -5px rgba(" +
    hexToRgb(primaryColor[0]) +
    ",.4)",
};
const singlegreenBoxShadow = {
  boxShadow:
    "0 4px 20px 0 rgba(" +
    hexToRgb(blackColor) +
    ",.14), 0 7px 10px -5px rgba(" +
    hexToRgb(singlegreenColor[0]) +
    ",.4)",
};
const darkgreenBoxShadow = {
  boxShadow:
    "0 4px 20px 0 rgba(" +
    hexToRgb(blackColor) +
    ",.14), 0 7px 10px -5px rgba(" +
    hexToRgb(darkgreenColor[0]) +
    ",.4)",
};
const brownBoxShadow = {
  boxShadow:
    "0 4px 20px 0 rgba(" +
    hexToRgb(blackColor) +
    ",.14), 0 7px 10px -5px rgba(" +
    hexToRgb(brownColor[0]) +
    ",.4)",
};
const pinkBoxShadow = {
  boxShadow:
    "0 4px 20px 0 rgba(" +
    hexToRgb(blackColor) +
    ",.14), 0 7px 10px -5px rgba(" +
    hexToRgb(pinkColor[0]) +
    ",.4)",
};
const neonBoxShadow = {
  boxShadow:
    "0 4px 20px 0 rgba(" +
    hexToRgb(blackColor) +
    ",.14), 0 7px 10px -5px rgba(" +
    hexToRgb(neonColor[0]) +
    ",.4)",
};
const licenseBoxShadow = {
  boxShadow:
    "0 4px 20px 0 rgba(" +
    hexToRgb(blackColor) +
    ",.14), 0 7px 10px -5px rgba(" +
    hexToRgb(licenseColor[0]) +
    ",.4)",
};
const multiplegreenBoxShadow = {
  boxShadow:
    "0 4px 20px 0 rgba(" +
    hexToRgb(blackColor) +
    ",.14), 0 7px 10px -5px rgba(" +
    hexToRgb(multiplegreenColor[0]) +
    ",.4)",
};
const deviceBoxShadow = {
  boxShadow:
    "0 4px 20px 0 rgba(" +
    hexToRgb(blackColor) +
    ",.14), 0 7px 10px -5px rgba(" +
    hexToRgb(deviceColor[0]) +
    ",.4)",
};
const redvoiletBoxShadow = {
  boxShadow:
    "0 4px 20px 0 rgba(" +
    hexToRgb(blackColor) +
    ",.14), 0 7px 10px -5px rgba(" +
    hexToRgb(redvoiletColor[0]) +
    ",.4)",
};
const infoBoxShadow = {
  boxShadow:
    "0 4px 20px 0 rgba(" +
    hexToRgb(blackColor) +
    ",.14), 0 7px 10px -5px rgba(" +
    hexToRgb(infoColor[0]) +
    ",.4)",
};
const cyanBoxShadow = {
  boxShadow:
    "0 4px 20px 0 rgba(" +
    hexToRgb(blackColor) +
    ",.14), 0 7px 10px -5px rgba(" +
    hexToRgb(cyanColor[0]) +
    ",.4)",
};
const greenBoxShadow = {
  boxShadow:
    "0 4px 20px 0 rgba(" +
    hexToRgb(blackColor) +
    ",.14), 0 7px 10px -5px rgba(" +
    hexToRgb(greenColor[0]) +
    ",.4)",
};
const lightgreenBoxShadow = {
  boxShadow:
    "0 4px 20px 0 rgba(" +
    hexToRgb(blackColor) +
    ",.14), 0 7px 10px -5px rgba(" +
    hexToRgb(lightgreenColor[0]) +
    ",.4)",
};
const lightblueBoxShadow = {
  boxShadow:
    "0 4px 20px 0 rgba(" +
    hexToRgb(blackColor) +
    ",.14), 0 7px 10px -5px rgba(" +
    hexToRgb(lightblueColor[0]) +
    ",.4)",
};
const navyblueBoxShadow = {
  boxShadow:
    "0 4px 20px 0 rgba(" +
    hexToRgb(blackColor) +
    ",.14), 0 7px 10px -5px rgba(" +
    hexToRgb(navyblueColor[0]) +
    ",.4)",
};
const lightorangeBoxShadow = {
  boxShadow:
    "0 4px 20px 0 rgba(" +
    hexToRgb(blackColor) +
    ",.14), 0 7px 10px -5px rgba(" +
    hexToRgb(lightorangeColor[0]) +
    ",.4)",
};
const successBoxShadow = {
  boxShadow:
    "0 4px 20px 0 rgba(" +
    hexToRgb(blackColor) +
    ",.14), 0 7px 10px -5px rgba(" +
    hexToRgb(successColor[0]) +
    ",.4)",
};
const warningBoxShadow = {
  boxShadow:
    "0 4px 20px 0 rgba(" +
    hexToRgb(blackColor) +
    ",.14), 0 7px 10px -5px rgba(" +
    hexToRgb(warningColor[0]) +
    ",.4)",
};
const orangeBoxShadow = {
  boxShadow:
    "0 4px 20px 0 rgba(" +
    hexToRgb(blackColor) +
    ",.14), 0 7px 10px -5px rgba(" +
    hexToRgb(orangeColor[0]) +
    ",.4)",
};
const dangerBoxShadow = {
  boxShadow:
    "0 4px 20px 0 rgba(" +
    hexToRgb(blackColor) +
    ",.14), 0 7px 10px -5px rgba(" +
    hexToRgb(dangerColor[0]) +
    ",.4)",
};
const roseBoxShadow = {
  boxShadow:
    "0 4px 20px 0 rgba(" +
    hexToRgb(blackColor) +
    ",.14), 0 7px 10px -5px rgba(" +
    hexToRgb(roseColor[0]) +
    ",.4)",
};

const warningCardHeader = {
  background:
    "linear-gradient(60deg, " + warningColor[1] + ", " + warningColor[2] + ")",
  ...warningBoxShadow,
};

const orangeCardHeader = {
  background:
    "linear-gradient(60deg, " + orangeColor[1] + ", " + orangeColor[2] + ")",
  ...orangeBoxShadow,
};

const successCardHeader = {
  background:
    "linear-gradient(60deg, " + successColor[1] + ", " + successColor[2] + ")",
  ...successBoxShadow,
};
const dangerCardHeader = {
  background:
    "linear-gradient(60deg, " + dangerColor[1] + ", " + dangerColor[2] + ")",
  ...dangerBoxShadow,
};
const infoCardHeader = {
  background:
    "linear-gradient(60deg, " + infoColor[1] + ", " + infoColor[2] + ")",
  ...infoBoxShadow,
};
const cyanCardHeader = {
  background:
    "linear-gradient(60deg, " + cyanColor[1] + ", " + cyanColor[2] + ")",
  ...cyanBoxShadow,
};
const greenCardHeader = {
  background:
    "linear-gradient(60deg, " + greenColor[1] + ", " + greenColor[2] + ")",
  ...greenBoxShadow,
};
const lightgreenCardHeader = {
  background:
    "linear-gradient(60deg, " +
    lightgreenColor[1] +
    ", " +
    lightgreenColor[2] +
    ")",
  ...lightgreenBoxShadow,
};
const lightblueCardHeader = {
  background:
    "linear-gradient(60deg, " +
    lightblueColor[1] +
    ", " +
    lightblueColor[2] +
    ")",
  ...lightblueBoxShadow,
};
const navyblueCardHeader = {
  background:
    "linear-gradient(60deg, " +
    navyblueColor[1] +
    ", " +
    navyblueColor[2] +
    ")",
  ...navyblueBoxShadow,
};
const lightorangeCardHeader = {
  background:
    "linear-gradient(60deg, " +
    lightorangeColor[1] +
    ", " +
    lightorangeColor[2] +
    ")",
  ...lightorangeBoxShadow,
};
const singlegreenCardHeader = {
  background:
    "linear-gradient(60deg, " +
    singlegreenColor[1] +
    ", " +
    singlegreenColor[2] +
    ")",
  ...singlegreenBoxShadow,
};
const darkgreenCardHeader = {
  background:
    "linear-gradient(60deg, " +
    darkgreenColor[1] +
    ", " +
    darkgreenColor[2] +
    ")",
  ...darkgreenBoxShadow,
};
const brownCardHeader = {
  background:
    "linear-gradient(60deg, " + brownColor[1] + ", " + brownColor[2] + ")",
  ...brownBoxShadow,
};
const pinkCardHeader = {
  background:
    "linear-gradient(60deg, " + pinkColor[1] + ", " + pinkColor[2] + ")",
  ...pinkBoxShadow,
};
const neonCardHeader = {
  background:
    "linear-gradient(60deg, " + neonColor[1] + ", " + neonColor[2] + ")",
  ...neonBoxShadow,
};
const licenseCardHeader = {
  background:
    "linear-gradient(60deg, " + licenseColor[1] + ", " + licenseColor[2] + ")",
  ...licenseBoxShadow,
};
const multiplegreenCardHeader = {
  background:
    "linear-gradient(60deg, " +
    multiplegreenColor[1] +
    ", " +
    multiplegreenColor[2] +
    ")",
  ...multiplegreenBoxShadow,
};
const deviceCardHeader = {
  background:
    "linear-gradient(60deg, " + deviceColor[1] + ", " + deviceColor[2] + ")",
  ...deviceBoxShadow,
};
const redvoiletCardHeader = {
  background:
    "linear-gradient(60deg, " +
    redvoiletColor[1] +
    ", " +
    redvoiletColor[2] +
    ")",
  ...redvoiletBoxShadow,
};
const primaryCardHeader = {
  background:
    "linear-gradient(60deg, " + primaryColor[1] + ", " + primaryColor[2] + ")",
  ...primaryBoxShadow,
};
const roseCardHeader = {
  background:
    "linear-gradient(60deg, " + roseColor[1] + ", " + roseColor[2] + ")",
  ...roseBoxShadow,
};

const cardActions = {
  margin: "0 20px 10px",
  paddingTop: "10px",
  borderTop: "1px solid " + grayColor[10],
  height: "auto",
  ...defaultFont,
};

const cardHeader = {
  margin: "-20px 15px 0",
  borderRadius: "3px",
  padding: "15px",
};

const card = {
  display: "inline-block",
  position: "relative",
  width: "100%",
  margin: "25px 0",
  boxShadow: "0 1px 4px 0 rgba(" + hexToRgb(blackColor) + ", 0.14)",
  borderRadius: "3px",
  color: "rgba(" + hexToRgb(blackColor) + ", 0.87)",
  background: whiteColor,
};

const defaultBoxShadow = {
  border: "0",
  borderRadius: "3px",
  boxShadow:
    "0 10px 20px -12px rgba(" +
    hexToRgb(blackColor) +
    ", 0.42), 0 3px 20px 0px rgba(" +
    hexToRgb(blackColor) +
    ", 0.12), 0 8px 10px -5px rgba(" +
    hexToRgb(blackColor) +
    ", 0.2)",
  padding: "10px 0",
  transition: "all 150ms ease 0s",
};

const title = {
  color: grayColor[2],
  textDecoration: "none",
  fontWeight: "300",
  marginTop: "30px",
  marginBottom: "25px",
  minHeight: "32px",
  fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
  "& small": {
    color: grayColor[1],
    fontWeight: "400",
    lineHeight: "1",
  },
};

const cardTitle = {
  ...title,
  marginTop: "0",
  marginBottom: "3px",
  minHeight: "auto",
  marginRight: "10px",
  fontWeight: "5px",
  // marginLeft: "10px",
  "& a": {
    ...title,
    marginTop: ".625rem",
    marginBottom: "0.75rem",
    minHeight: "auto",
  },
};

const cardSubtitle = {
  marginTop: "-.375rem",
};

const cardLink = {
  "& + $cardLink": {
    marginLeft: "1.25rem",
  },
};

export {
  hexToRgb,
  //variables
  drawerWidth,
  transition,
  container,
  boxShadow,
  card,
  defaultFont,
  primaryColor,
  warningColor,
  orangeColor,
  dangerColor,
  successColor,
  infoColor,
  cyanColor,
  greenColor,
  lightgreenColor,
  lightblueColor,
  navyblueColor,
  lightorangeColor,
  singlegreenColor,
  darkgreenColor,
  multiplegreenColor,
  deviceColor,
  redvoiletColor,
  roseColor,
  grayColor,
  blackColor,
  whiteColor,
  brownColor,
  pinkColor,
  neonColor,
  licenseColor,
  brownBoxShadow,
  primaryBoxShadow,
  infoBoxShadow,
  navyblueBoxShadow,
  successBoxShadow,
  warningBoxShadow,
  orangeBoxShadow,
  singlegreenBoxShadow,
  darkgreenBoxShadow,
  multiplegreenBoxShadow,
  deviceBoxShadow,
  lightgreenBoxShadow,
  lightblueBoxShadow,
  redvoiletBoxShadow,
  dangerBoxShadow,
  licenseBoxShadow,
  neonBoxShadow,
  roseBoxShadow,
  warningCardHeader,
  orangeCardHeader,
  successCardHeader,
  dangerCardHeader,
  greenCardHeader,
  singlegreenCardHeader,
  lightblueCardHeader,
  darkgreenCardHeader,
  brownCardHeader,
  pinkCardHeader,
  neonCardHeader,
  licenseCardHeader,
  multiplegreenCardHeader,
  deviceCardHeader,
  redvoiletCardHeader,
  lightgreenCardHeader,
  lightorangeCardHeader,
  navyblueCardHeader,
  infoCardHeader,
  cyanCardHeader,
  greenBoxShadow,
  primaryCardHeader,
  roseCardHeader,
  cardActions,
  cardHeader,
  defaultBoxShadow,
  title,
  cardTitle,
  cardSubtitle,
  cardLink,
};
